/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lower_Quaint_Skate_SingInputs */

const fr_lower_quaint_skate_sing = /** @type {(inputs: Lower_Quaint_Skate_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps requis`)
};

/**

* @param {Lower_Quaint_Skate_SingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const lower_quaint_skate_sing = /** @type {((inputs?: Lower_Quaint_Skate_SingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lower_Quaint_Skate_SingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_lower_quaint_skate_sing(inputs)
});